import React, { useEffect, useState } from "react";
import styles from "./Rooms.module.scss";
import { getSession } from "../../services/Account/Supabase";
import { useNavigate } from "react-router-dom";
import WebSocketService from "services/WebSocketService/WebSocketService";
import { Player } from "services/Account/types/Player";

interface PlayerInfo {
    [username: string]: string; // Dynamic key-value pair (username: color)
}

interface Room {
    room_id: string;
    player_count: number;
    game_info: {
        player_info: PlayerInfo[];
    };
}

const Rooms: React.FC = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState<Player | null>(null);
    const [rooms, setRooms] = useState<Room[]>([]);
    const [wsService, setWsService] = useState<WebSocketService | null>(null);

    useEffect(() => {
        const setupSession = async () => {
            const session = await getSession();
            if (session) {
                setUser({
                    name: session.user.user_metadata?.name || "Guest",
                    email: session.user.email || "No EMAIL",
                    player_id: session?.user?.id,
                });
            } else {
                navigate("/login");
            }
        };
        setupSession();
    }, [navigate]);

    useEffect(() => {
        if (!user) return;

        const handleWebSocketMessage = (data: any) => {
            console.log("message >>", data);

            switch (data.type) {
                case "all_rooms":
                    setRooms(data.rooms || []);
                    break;
                case "room_created":
                    setRooms((prev) => [...prev, { room_id: data.room_id, player_count: data.player_count, game_info: { player_info: [] } }]);
                    break;
                case "room_updated":
                    setRooms((prev) =>
                        prev.map((room) =>
                            room.room_id === data.room_id
                                ? { ...room, player_count: data.player_count, game_info: { player_info: data.game_info?.player_info || [] } }
                                : room
                        )
                    );
                    break;
                case "room_deleted":
                    setRooms((prev) => prev.filter((room) => room.room_id !== data.room_id));
                    break;
                case "redirect_to_room":
                    joinRoom(data.room_id);
                    break;
                default:
                    console.error("Unknown message type:", data);
            }
        };

        const socketUrl = process.env.REACT_APP_SOCKET_URL + '/rooms' || "";
        const ws = new WebSocketService("rooms-page", socketUrl, handleWebSocketMessage, user);

        setWsService(ws);

        return () => {
            ws.closeConnection();
        };
    }, [user]);

    const handleCreateRoom = () => {
        if (wsService) {
            wsService.sendMessage({ type: "create_room", player_id: user?.player_id || '' });
        } else {
            console.error("WebSocketService is not initialized.");
        }
    };

    if (!user) {
        return <div className={styles.wrapper}>Loading...</div>;
    }

    const joinRoom = (roomId: string) => {
        navigate(`/game?room_id=${roomId}`);
    };

    return (
        <div className="app">
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    <h1>Rooms</h1>
                </div>
                <div className={styles.createRoom}>
                    <h2>Create a New Room</h2>
                    <button onClick={handleCreateRoom} className={styles.button}>
                        Create Room
                    </button>
                </div>
                <div className={styles.roomsList}>
                    <h2>Available Rooms</h2>
                    {rooms.length > 0 ? (
                        <ul>
                            {rooms.map((room) => (
                                <li key={room.room_id} className={styles.roomCard}>
                                    <div className={styles.roomDetails}>
                                        <div className={styles.playersList}>
                                            <h4>Players:</h4>
                                            {room.game_info.player_info.length > 0 ? (
                                                <ul>
                                                    {room.game_info.player_info.map((player, index) => {
                                                        console.log(player)
                                                        const [username, color] = Object.entries(player)[0]; // Extract key-value
                                                        return (
                                                            <li key={index} className={styles.playerItem}>
                                                                <div className={styles.colorIndicator} style={{ backgroundColor: player.color }}></div>
                                                                <span className={styles.playerName}>{player.name}</span>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            ) : (
                                                <p>No players joined yet</p>
                                            )}
                                        </div>
                                        <p>ID: {room.room_id}</p>
                                    </div>
                                    <button onClick={() => joinRoom(room.room_id)}>Join Room</button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No rooms available</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Rooms;
